import Axios, { AxiosError, InternalAxiosRequestConfig } from 'axios';

import { get, isArray, isObject, map, merge, pickBy } from 'lodash-es';
import { getConfig } from '../config';
import { openNotification } from '../helpers';

//import { setupCache } from 'axios-cache-adapter';
const LOCAL_DEBUG = true;
type Channels = 'isac-rest' | 'api';

// Mai url è preso dal file esterno api_url.js
export const MAIN_URL = () => {
  const url = getConfig().baseURL;
  return url as string;
};

const baseURLPrefix: Record<Channels, string> = {
  'isac-rest': 'isac-rest',
  api: 'API',
};

console.info('MAIN_URL', MAIN_URL());

const API_VERBOSE = false;
const API_DEBUG = false;
export interface ApiResponse<T = any> {
  data: T[];
  status?: number;
  success: boolean;
  pagination?: ResponsePagination;
}

export interface ResponsePagination {
  page: number;
  pageCount: number;
  pageSize: number;
  total: number;
  recordCount?: number;
}
interface ServerData {
  foo: string;
  bar: number;
}

interface ServerError {
  name: any;
  title?: string;
  message: any;
  code: number;
  status: number;
  errors?: string | any[];
  error?: string;
  type: string;
  hideError?: boolean;
}

interface IApiCall extends Omit<InternalAxiosRequestConfig, 'headers'> {
  channel?: Channels;
  headers?: any;
  hasUpload?: boolean;
  /** non mostra alert di errore */
  skipError?: boolean;
  credentials?: string;
}

//@ts-ignore
interface IApiError extends AxiosError {
  config: IApiCall;
}
// Create `axios-cache-adapter` instance
// const AXIOS_CACHE = setupCache({
//   maxAge: 3000, // 15 * 60 * 1000, //15 minuti
//   //debug: true,
//   ignoreCache: true,
//   // exclude: {
//   //   // {Array} List of regular expressions to match against request URLs.
//   //   paths: [],
//   // },
// });
const default_config = (): IApiCall => ({
  method: 'GET',
  baseURL: MAIN_URL(),
  timeout: LOCAL_DEBUG ? 3 * 60 * 1000 : 20 * 1000,
  headers: {
    'Content-Type': 'application/json',
    //'Cache-Control': 'public',
    // 'Cookie': 'XDEBUG_SESSION=PHPSTORM'
  },
  withCredentials: true,
  responseType: 'json',
  maxRedirects: 1,
  validateStatus(status) {
    return status < 400; // Reject only if the status code is greater than or equal to 400
  },
  //adapter: AXIOS_CACHE.adapter,
});
export const API = Axios.create(default_config());

// Add a request interceptor
API.interceptors.request.use(
  //@ts-ignore
  async (config: IApiCall) => {
    // Do something before request is sent

    return config;
  },
  (error) => {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
API.interceptors.response.use(
  (response: any) => {
    // Do something with response data
    // const { excludedFromCache, fromCache } = response;
    // console.log({ excludedFromCache, fromCache });
    if (response.status >= 400 || response.success === false) {
      if (API_DEBUG) {
        //debugger;
      }
      return Promise.reject(response.data);
    } else {
      let pagination: ResponsePagination | undefined = undefined;

      if (response.config.params && response.config.params.pagination) {
        //debugger;
        const {
          'x-pagination-current-page': page = 1,
          'x-pagination-page-count': pageCount = 0,
          'x-pagination-per-page': pageSize = 20,
          'x-pagination-total-count': total = 0,
        } = response.headers;
        pagination = { page, pageCount, pageSize, total };

        //console.log("pagination", pagination)
      }

      const returnData: any = {
        data:
          get(response, 'data.data.list') ||
          get(response, 'data.data') ||
          get(response, 'data'),
        pagination,
        success: true,
      };
      return Promise.resolve(returnData);
    }
  },
  (error: IApiError) => {
    // Do something with response error
    if (API_DEBUG) {
      //debugger;
    }

    if (!error?.config?.skipError) {
      const onUnauthorized = getConfig().onUnauthorized;
      // 401 = sessione scaduta: la reazione (logout/redirect) la decide l'app.
      // Escluso il login, dove il 401 significa "credenziali errate".
      if (
        error?.response?.status === 401 &&
        !isLoginRequest(error?.config) &&
        onUnauthorized
      ) {
        onUnauthorized();
      } else {
        showErrorMessage(error);
      }
    }
    if (isLoginRequest(error?.config)) {
      // Il login mappa i messaggi sullo status: va propagato.
      return Promise.reject(
        new ApiError({
          status: error?.response?.status,
          data: error?.response?.data,
        })
      );
    }

    return Promise.reject(error?.response?.data || 'Generic Error');
  }
);

/**
 * Errore applicativo che conserva lo status HTTP.
 *
 * L'interceptor rigetta normalmente con il solo body della risposta: per il
 * login il body e' l'HTML di errore di JBoss, quindi lo status andrebbe perso
 * e il chiamante non potrebbe distinguere credenziali errate (401) da password
 * bloccata (402) o scaduta (410). Usato solo sulla chiamata di autenticazione,
 * per non cambiare la forma dell'errore alle altre chiamate.
 */
export class ApiError extends Error {
  status?: number;
  code?: string;
  data?: any;

  constructor({
    status,
    code,
    data,
    message,
  }: {
    status?: number;
    code?: string;
    data?: any;
    message?: string;
  }) {
    super(message || code || `API error${status ? ` ${status}` : ''}`);
    this.name = 'ApiError';
    this.status = status;
    this.code = code;
    this.data = data;
  }
}

const isLoginRequest = (config?: IApiCall) =>
  config?.headers?.['X-REQUESTED-FOR'] === 'authentication';

export const API_CALL = async (config: IApiCall) => {
  const axiosConfig = merge(default_config(), config);
  if (API_DEBUG) {
    //debugger;
  }
  axiosConfig.url =
    baseURLPrefix[axiosConfig.channel || 'api'] + axiosConfig.url;
  API_DEBUG &&
    console.log('🚀 ~ constAPI_CALL= ~ axiosConfig.url:', axiosConfig.url);
  if (axiosConfig.params) {
    axiosConfig.params = formatParams(axiosConfig.params);
  }

  if (axiosConfig.hasUpload || axiosConfig?.data?.file_upload) {
    axiosConfig.headers['Content-Type'] = 'multipart/form-data';
    if (axiosConfig.data) {
      axiosConfig.data = jsonToFormData(axiosConfig.data);
    }
  }
  //   if (axiosConfig?.hasUpload === false) {
  //     axiosConfig.headers['Content-Type'] = 'application/json';
  //   }

  const xsrfToken = document.cookie
    .split('; ')
    .find((row) => row.startsWith('XSRF-TOKEN='))
    ?.split('=')[1];
  //console.log('🚀 ~ constAPI_CALL= ~ xsrfToken:', xsrfToken);
  if (xsrfToken) {
    axiosConfig.headers['X-Xsrf-Token'] = xsrfToken;
    axiosConfig.headers['XSRF-TOKEN'] = xsrfToken;
  }

  const urlCalled = `${axiosConfig.baseURL} ${axiosConfig.url}`;
  API_VERBOSE &&
    console.info(
      'API_CALL',
      `${axiosConfig.method} => ${axiosConfig.url}`,
      axiosConfig.params || axiosConfig.data || ''
    );
  // console.info('axiosConfig', axiosConfig)

  return API(axiosConfig)
    .then((responseData: any) => {
      API_VERBOSE &&
        console.info(
          'API_SUCCESS => ' + axiosConfig.url,
          responseData.data || responseData
        );

      if (API_DEBUG) {
        //debugger;
      }
      if (responseData.pagination) {
        return responseData;
      } else {
        return responseData.data ?? responseData;
      }
    })
    .catch((err) => {
      console.warn('API_ERROR ' + axiosConfig.url, err);
      if (API_DEBUG) {
        //debugger;
      }
      return Promise.reject(err);
    });
};

const showErrorMessage = (error: IApiError) => {
  if (API_DEBUG) debugger;

  const errorResponse: ServerError =
    //@ts-ignore
    error?.response?.data?.data ||
    error?.response?.data ||
    error?.response ||
    error;

  let errorMessage = unescape(
    `${
      errorResponse?.message ||
      errorResponse?.errors ||
      errorResponse?.error ||
      errorResponse?.code ||
      errorResponse?.type
    }`
  );

  if (errorResponse.name && errorResponse.name === 'Unauthorized') {
    //debugger;

    openNotification({
      message: errorMessage || 'Utente non autorizzato',
      type: 'error',
    });
  } else if (errorResponse.name && errorResponse.name === 'multiple_error') {
    if (isArray(errorResponse.errors) || isObject(errorResponse.errors)) {
      errorMessage = '';
      map(errorResponse.errors, (error, field) => {
        errorMessage += `${field} : ${error}
			`;
      });
    }
  } else if (isArray(errorResponse)) {
    errorMessage = '';
    map(errorResponse?.errors || errorResponse, ({ message, field }, index) => {
      errorMessage += `${field} : ${message}
			`;
    });
  } else {
    errorMessage = unescape(
      `${
        errorResponse.message ||
        errorResponse.errors ||
        errorResponse.error ||
        errorResponse.code ||
        errorResponse.type
      }`
    );
  }

  const { url, method, params, data, headers } = error.config;
  const jsonError = {
    payload: {
      url: url?.replace(MAIN_URL(), ''),
      method,
      headers,
      params,
      data,
    },
    response: errorResponse,
  };
  if (API_DEBUG) debugger;
  if (errorResponse.hideError) return;

  showErrorNotification(errorMessage, jsonError);
};

export const showErrorNotification = (
  errorMessage: string,
  jsonError: any = {}
) => {
  openNotification({
    //message: unescape(`${errorResponse.title || errorResponse.name || 'Errore '}`),
    message: 'Errore',
    type: 'error',
  });
};
const formatParams = (params: any) => {
  //console.info('formatParams', params);

  //params =pickBy(params,identity)
  params = pickBy(params, (v) => v !== null && v !== undefined && v !== '');
  if (params.pagination) {
    // page: 1,
    //   count : 0,
    //     perPage : 20,
    //       total : 0
  }
  return params;
};
export default API_CALL;

const buildFormData = (
  formData: FormData,
  data: { [x: string]: any } | null,
  parentKey = ''
) => {
  if (
    data &&
    typeof data === 'object' &&
    !(data instanceof Date) &&
    !(data instanceof File)
  ) {
    Object.keys(data).forEach((key) => {
      buildFormData(
        formData,
        data[key],
        parentKey ? `${parentKey}[${key}]` : key
      );
    });
  } else {
    const value: any = data == null ? '' : data;

    formData.append(parentKey, value);
  }
};

export const jsonToFormData = (data: any) => {
  const formData = new FormData();

  buildFormData(formData, data);

  return formData;
};
